import React, { memo } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { setIsModalVisible } from '@/state/modalSlice';
import dynamic from 'next/dynamic';
import Cookies from '@repo/ui/src/components/Cookies/Cookies';
import { useIsDesktop } from '@repo/ui/src/providers/DeviceProvider';
import { useNavigation } from '@repo/ui/src/providers/NavigationProvider';
import Menu from '@/components/Menu';

const Cursor = dynamic(() => import('@repo/ui/src/components/Cursor/Cursor'), { ssr: false });
const Modal = dynamic(() => import('@repo/ui/src/components/Modal/Modal'), { ssr: false });
const Footer = dynamic(() => import('@/components/Footer', { ssr: false }));

const Layout = ({ cookies, children, menu, footer }) => {
	const dispatch = useDispatch();
	const router = useRouter();

	const isLoaded = useNavigation((state) => state.isLoaded);
	const isProjectSite = router.asPath.split('/').length === 3 && router.asPath.includes('projects');
	const isStorySite = router.asPath.split('/').length === 2 && router.asPath.includes('story');
	const hideFooter = isProjectSite || isStorySite;
	const isModalVisible = useSelector((state) => state.modal.isModalVisible);
	const modalData = useSelector((state) => state.modal.modalData);
	const isDesktop = useIsDesktop(true);
	const isHtmlLoaded = useNavigation((state) => state.isHtmlLoaded);

	return (
		<>
			{isModalVisible && (
				<Modal
					isVisible={isModalVisible}
					handleCloseButton={() => dispatch(setIsModalVisible(false))}
					data={{
						header: modalData.header,
						text: modalData.description,
						buttonText: modalData.closeButtonText,
						buttonTextOpen: modalData.openButtonText,
						externalUrl: modalData.externalUrl,
					}}
				/>
			)}
			{isDesktop && isHtmlLoaded && <Cursor />}
			<Menu menu={menu} />
			<Cookies data={cookies} />
			{children}
			{!hideFooter && isLoaded && <Footer data={footer} />}
		</>
	);
};

export default memo(Layout);